import Mock from "../mock";

const database = {
  information: {
    name: 'Emily Hoang',
    aboutContent1: "I'm a software engineer who takes pride in building systems that are not only scalable and reliable, but genuinely make life easier for the people who use and maintain them.",
    aboutContent2: "👨‍💻 By day, I immerse myself in the world of software development, crafting high-quality code and architecting solutions that make an impact.",
    aboutContent3: "🌟 Over the last few years, I've had the opportunity to lead complex initiatives like performance testing across 13+ services, introducing canary releases with zero customer impact, strengthening observability and resilience across multiple platforms.",
    aboutContent4: "🚀 I enjoy connecting the dots between infrastructure, code, and people. Whether setting up AWS and Kubernetes foundations, refining CI/CD pipelines, or championing infrastructure as code, I focus on clarity, collaboration, and craftsmanship.",
    aboutContent5: "I've found that technical excellence comes not just from writing good code, but from fostering an environment where others can thrive — through mentorship, shared learning, and thoughtful communication.",
    age: 33,
    phone: '',
    nationality: 'Vietnamese, Australian',
    language: 'Vietnamese, English',
    email: 'nhung@nhunghoang.com',
    address: 'Melbourne, Victoria, Australia',
    freelanceStatus: 'Not Available',
    socialLinks: {
      facebook: '',
      twitter: '',
      pinterest: '',
      behance: '',
      linkedin: 'www.linkedin.com/in/emily-hoang-0788b19a',
      dribbble: '',
      github: 'https://github.com/emily-hoang'
    },
    brandImage: '/images/brand-image.jpg',
    aboutImage: '/images/about-image.jpg',
    aboutImageLg: '/images/about-image-lg.jpg',
    cvfile: '/files/emily-hoang-cv.pdf'
  },
  services: [
    {
      title: "Web Development",
      icon: 'brush-alt',
      details: "Strong background in creating dynamic and responsive web applications. Skilled in front-end and back-end technologies, delivering user-friendly and high-performance solutions. Demonstrates a solid understanding of modern web frameworks and best practices. Committed to continuous learning, agile methodologies, and collaborative teamwork to deliver exceptional software solutions."
    },
    {
      title: "Backend Services Development",
      icon: 'code',
      details: "Specializing in building robust RESTful APIs, setting up comprehensive observability frameworks, and creating efficient build and development pipelines. Proficient in designing and implementing extensive test suites to ensure code quality and reliability. Demonstrates a strong commitment to best practices in software development, including continuous integration and deployment (CI/CD), and agile methodologies. Known for a detail-oriented approach and effective collaboration within cross-functional teams to deliver high-performance backend solutions."
    },
    {
      title: "AWS Solutions",
      icon: 'mobile',
      details: "Skilled in leveraging AWS services to optimize cloud infrastructure, enhance performance, and maintain robust security standards. Demonstrates expertise in implementing scalable and reliable solutions, adhering to industry best practices, and continuously improving cloud-based applications. Known for a meticulous approach and effective collaboration with cross-functional teams to deliver high-quality AWS solutions."
    }
  ],
  skills: [
    {
      title: "Programing Languages: Java, C#, Javascript, Typescript, React, Ruby, Terraform, CloudFormation",
      value: 95
    },
    {
      title: "AWS Services: VPC, NACL, SG, Private Link, EC2, ASG, S3, EFS, Glue, Kinesis, MSK, SNS, SQS, EKS, ECR, ECS, CloudWatch, CloudFormation, DMS, ELB, IAM, KMS, Kafka",
      value: 90
    },
    {
      title: "Databases: DynamoDB, Amazon RDS, MySQL, Aurora Serverless v2",
      value: 70
    },
    {
      title: "Observability Tools: Datadog, New Relic, Grafana, Splunk, Sumo Logic, Lighthouse",
      value: 85
    },
    {
      title: "Build & Deployment Pipelines: GitHub Actions, TeamCity, ArgoCD, Argo Rollouts",
      value: 80
    }
  ],
  domains: [
    {
      id: 1,
      title: "Banking",
      subtitle: "Modernising A Critical Service In The Bank System",
      imageUrl: "/images/portfolio-banking.png",
      largeImageUrl: ["/images/portfolio-image-1-lg.jpg"],
      url: ''
    },
    {
      id: 2,
      title: "Airline",
      subtitle: "Enhancing System Observability And Performance",
      imageUrl: "/images/portfolio-airline.png",
      largeImageUrl: [
        "/images/portfolio-image-4-lg.jpg",
        "/images/portfolio-image-4-lg2.jpg"
      ],
      url: ''
    },
    {
      id: 3,
      title: "Australian Retail",
      subtitle: "Building a large-scale subscription platform.",
      imageUrl: "/images/portfolio-australian-retail.png",
      url: 'https://pinterest.com'
    },
    {
      id: 4,
      title: "Collaboration Software - SaaS",
      subtitle: "Cloud Migration & Database Migration.",
      imageUrl: "/images/portfolio-Collaboration-SaaS.png",
      largeImageUrl: ["/images/portfolio-image-3-lg.jpg"],
      url: '#'
    },
    {
      id: 5,
      title: "Healthcare",
      subtitle: "Enhancing & Expanding the capability of the Bahmni software.",
      imageUrl: "/images/portfolio-healthcare.png",
      largeImageUrl: ["/images/portfolio-image-5-lg.jpg"]
    },
    {
      id: 6,
      title: "Accounting Software - SaaS",
      subtitle: "Building a Proactive Communication Platform, Modernising Critical Products",
      imageUrl: "/images/portfolio-Accounting-SaaS.png",
      largeImageUrl: ["/images/portfolio-image-6-lg.jpg"]
    },
    {
      id: 7,
      title: "Online Retail",
      subtitle: "Enhancing the E-comerce capabilities of an established application.",
      imageUrl: "/images/portfolio-general-retail.png",
      largeImageUrl: ["/images/portfolio-image-7-lg.jpg"],
      url: 'https://twitter.com'
    }
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "November 2023 - Present",
        position: "Full Stack Engineer",
        company: "SaaS Company",
        details: "Over the last 2 years, I've been part of a large initiative which involving multiple cross-functional teams who came together to redesign and rebuild several of the company’s critical products, aiming to improve scalability, reliability, and user experience. This large-scale effort touched numerous services and required careful coordination, planning, and execution across engineering, platform, and product teams. My contributions focused on ensuring these new systems could perform reliably at scale and be delivered with confidence. I had the opportunity to lead performance testing across 13+ critical microservices, making sure each service met clearly defined scalability and performance targets. Collaborating closely with platform and product teams, I helped navigate technical constraints, coordinate test environments, and execute large-scale tests in a production-like environment. To enable independent, repeatable testing, I worked closely with the engineering team to design and implement an isolated performance testing setup for a key backend service, including IAM strategies, standalone Kubernetes deployments, and GitHub Actions pipelines. This setup became the foundation for continuous performance validation, allowing teams to test without disrupting shared environments. My stakeholders were aligned on with clear communication on test scopes, dependencies, architecture, and resource requirements. When technical challenges arose—such as authentication service integrations or network rate-limiting—I proactively resolved them to keep progress on track. Mentoring engineers was another key part of my role, guiding them in automating large- scale test data creation, setting up pipelines, and coordinating performance test execution across teams.I also documented results, blockers, and actionable recommendations, helping service owners make informed decisions to improve system reliability and scalability.",
        techStack: "Tech Stack: C#, TypeScript, JavaScript, Terraform, AWS, Kubernetes, GitHub Actions, Team City, Argo Rollouts, New Relic, k6, Grafana"
      },
      {
        id: 2,
        year: "October 2023 - November 2024",
        position: "Full Stack Engineer",
        company: "SaaS Company",
        details: "I was part of a project that enables the client to seamlessly transition their customers into using a modernised service that provides more functionalities with multiple robust back-end systems. This involves building a RESTful API following best practices, design principles, and comprehensive observability while integrating with various services, ensuring data consistency, and optimising performance to handle diverse client requirements. On the frontend, I focus on creating intuitive interfaces that interact efficiently with the API, ensuring a smooth user experience. By leveraging the latest technologies and best practices, I aim to deliver a scalable and maintainable solution that enhances overall system functionality and user satisfaction.",
        techStack: "Tech Stack: C#, TypeScript, JavaScript, Terraform, AWS, Kubernetes, GitHub Actions, Team City, New Relic, k6"
      },
      {
        id: 3,
        year: "July 2023 - September 2023",
        position: "DevOps Engineer",
        company: "Banking Company",
        details: "Modernised a critical service by replacing the outdated tech stack with an endorsed framework, establishing the new service and CI/CD pipeline, and documenting processes for team-wide adoption. Built a streamlined cloud deployment pipeline automating build, testing, security scanning, and deployment processes, reducing manual intervention and errors. Designed and implemented a high-availability platform, decoupling external service failures, improving fault tolerance, and enhancing system reliability. Developed backend endpoints and enabled frontend integration aligned with high-availability design. Key Achievements: Delivered scalable, maintainable services; implemented robust CI/CD pipelines; fostered knowledge sharing; improved system uptime and reliability.",
        techStack: "Tech Stack: AWS (Kafka, IAM, Redis), Terraform, TypeScript, Ruby, GitHub Actions"
      },
      {
        id: 4,
        year: "Feb 2023 - May 2023",
        position: "DevOps Engineer",
        company: "Airline Company",
        details: "My objective was enhancing system observability and performance. My focus was on establishing a robust monitoring infrastructure based on the four golden signals: latency, traffic, errors, and saturation. I implemented Application Performance Monitoring (APM) for multiple services to deliver clear and actionable insights into the systems behaviour, enabling proactive issue resolution and performance optimisation. Additionally, I built reusable Terraform modules to define and set Service Level Objectives (SLOs) to establish clear performance and reliability goals, ensuring alignment across teams and common alerts to provide early detection of issues before they impact users, allowing teams to address problems promptly and reduce downtime. To support these efforts, I wrote a comprehensive Observability Guide that serves as a foundational resource for over 100 services, standardising best practices and streamlining the observability setup.",
        techStack: "Tech Stack: AWS (S3, IAM, DynamoDB), Terraform, Java, TypeScript, Kotlin, Datadog"
      },
      {
        id: 5,
        year: "August 2021 - Feb 2022",
        position: "Full Stack Engineer",
        company: "Australian Retail Company",
        details: "I was part of a team that built a large-scale subscription platform for Australian customers. I contributed to developing the subscription service from the ground up, focusing on event-driven design and microservices architecture. My role involved designing and implementing functionalities for managing multiple subscription options and handling payment processing. Additionally, I played an important role in ensuring a smooth migration for existing customers to the new platform, facilitating a seamless transition and maintaining service continuity throughout the process.",
        techStack: "Tech Stack: AWS, Kafka & Avro, Spring Boot with Kotlin, Golang, GraphQL, React, Terraform, Stripe/PayPal/Braintree, Auth0, k6"
      },
      {
        id: 6,
        year: "November 2020 - July 2021",
        position: "Infrastructure Engineer",
        company: "SaaS Company",
        details: "I contributed to the success of two significant migration projects. The first project involved migrating a critical service to the AWS cloud by enhancing the internal PaaS capabilities. Over the course of three months, hundreds of services was successfully migrated from their datacenter to AWS. This new capability created a new pathway for services who utilised this internal platform to be deployed into a shared and centralised managed cloud environment. The second project focused on seamlessly migrating a critical service’s database tables containing billions of records from AWS RDS to DynamoDB, ensuring that the transition was smooth and did not impact customer experience. These migrations not only improved scalability and efficiency but also paved the way for more streamlined cloud-based operations in the future.",
        techStack: "Tech Stack: AWS (CloudFormation, EC2, SQS, VPC, SNS, DynamoDB, RDS), Ansible, Python, Node.js (TypeScript), Bamboo, BitBucket"
      },
      {
        id: 7,
        year: "February 2020 - March 2020",
        position: "Back-end Engineer",
        company: "Healthcare Company",
        details: "I worked on integrating new functionalities into Bahmni - an open-source hospital management system designed to provide a comprehensive electronic medical record (EMR) and hospital information system (HIS) for low-resource environments. These new capabilities were built to support various COVID-19-related tasks amid the pandemic. This included developing features for testing, managing patient information (such as travel history), securely sharing data with relevant authorities and systems, and recording health data of COVID-19 patients. I also contributed to building the capability of facilitating video calls between patients and doctors through a lightweight, freely accessible application, improving remote healthcare access and communication.",
        techStack: "Tech Stack: .Net Core, C#, Docker, Postgres, SQL "
      },
      {
        id: 8,
        year: "November 2019 - June 2020",
        position: "Full Stack Engineer",
        company: "Accounting Software Company",
        details: "I was part of a team that built a platform for delivering timely and impactful customer communications. My focus was mainly around creating solutions that drive behavioural change by using event-driven architecture. This included designing systems for personalized messaging, tracking customer interactions, and analyzing engagement data to optimize communication strategies. The platform aimed to enhance customer engagement and influence behaviour through targeted, timely, and relevant messages.",
        techStack: "Tech Stack: AWS (DynamoDB, S3, SNS, SQS, Glue, Kinesis, CloudWatch), Terraform, New Relic, Sumo Logic, .Net Core, Kubernetes, Docker, TeamCity"},
      {
        id: 9,
        year: "October 2019 - November 2019",
        position: "Full Stack Engineer",
        company: "ThoughtWorks University",
        details: "As part of ThoughtWorks university, I worked on a simulated project to expand the feature set of an e-commerce website, I focused on enhancing user experience while addressing both security and functional issues of the existing application. My role involved developing new features such as streamlined navigation, personalized recommendations, and intuitive checkout processes. Concurrently, I implemented robust security measures to protect user data and prevent vulnerabilities. By balancing feature expansion with comprehensive security and performance improvements, I contributed to a more engaging and secure e-commerce platform.",
        techStack: "Tech Stack: Java, Spring, JUnit, Mockito, Selenium, React, SQL, GoCD"
      }
    ],
    educationExperience: []
  },
  blogs: [
  {
      id: 1,
      title: 'A Simple & Secure Network Setup With AWS',
      featuredImage: '/images/simple-secure-vpc-network-setup.png',
      filesource: 'a-simple-and-secure-network-setup-with-aws.md',
      createDay: "2",
      createMonth: 'February',
      createYear: "2026"
    },
    {
      id: 2,
      title: 'Multi-AZ Enterprise Network Setup',
      featuredImage: '/images/multi-azs-vpc-setup.png',
      filesource: 'multi-AZs-VPC-setup.md',
      createDay: "2",
      createMonth: 'February',
      createYear: "2026"
    },
    {
      id: 3,
      title: 'Part 1 - The Performance Testing Guide I Wish I Had 13 Services Ago',
      featuredImage: '/images/performance-testing-part-1.png',
      filesource: 'performance-testing-part-1.md',
      createDay: "28",
      createMonth: 'October',
      createYear: "2025"
    },
    {
      id: 4,
      title: 'Part 2 - The Performance Testing Guide I Wish I Had 13 Services Ago',
      featuredImage: '/images/performance-testing-part-2.png',
      filesource: 'performance-testing-part-2.md',
      createDay: "28",
      createMonth: 'October',
      createYear: "2025"
    },
    {
      id: 5,
      title: 'Part 3 - The Performance Testing Guide I Wish I Had 13 Services Ago',
      featuredImage: '/images/performance-testing-part-3.png',
      filesource: 'performance-testing-part-3.md',
      createDay: "13",
      createMonth: 'November',
      createYear: "2025"
    },
    {
      id: 6,
      title: 'Part 1 — From Adversity To Algorithms: The Journey Of Emily Hoang',
      featuredImage: '/images/blog-image-emily-story-1.png',
      filesource: 'from-adversity-to-algorithms-part-1.md',
      createDay: "03",
      createMonth: 'October',
      createYear: "2023"
    },
    {
      id: 7,
      title: 'Part 2 — From Adversity To Algorithms: The Journey Of Emily Hoang',
      featuredImage: '/images/blog-image-emily-story-2.png',
      filesource: 'emily-blogs/from-adversity-to-algorithms-part-2.md',
      createDay: "03",
      createMonth: 'October',
      createYear: "2023"
    },
    {
      id: 8,
      title: 'Part 3 — From Adversity To Algorithms: The Journey Of Emily Hoang',
      featuredImage: '/images/blog-image-emily-story-3.png',
      filesource: 'from-adversity-to-algorithms-part-3.md',
      createDay: "03",
      createMonth: 'October',
      createYear: "2023"
    },
    {
      id: 9,
      title: 'Part 4 — From Adversity To Algorithms: The Journey Of Emily Hoang',
      featuredImage: '/images/blog-image-emily-story-4.png',
      filesource: 'from-adversity-to-algorithms-part-4.md',
      createDay: "04",
      createMonth: 'October',
      createYear: "2023"
    },
    {
      id: 10,
      title: 'Part 5 — From Adversity To Algorithms: The Journey Of Emily Hoang',
      featuredImage: '/images/blog-image-emily-story-5.png',
      filesource: 'from-adversity-to-algorithms-part-5.md',
      createDay: "04",
      createMonth: 'October',
      createYear: "2023"
    },
    {
      id: 11,
      title: 'Crafting Maintainable Code with SOLID Principles',
      featuredImage: '/images/blog-image-SOLID.png',
      filesource: 'software-design-with-SOLID-principles.md',
      createDay: "31",
      createMonth: 'October',
      createYear: "2023"
    },
    {
      id: 12,
      title: 'Pair Programming Unveiled: A Software Consultant\'s Perspective',
      featuredImage: '/images/blog-image-7.jpg',
      filesource: 'pair-programming.md',
      createDay: "05",
      createMonth: 'October',
      createYear: "2023"
    },
    {
      id: 13,
      title: 'AWS Summit Sydney 2024 — Exploring the Future of AI',
      featuredImage: '/images/blog-image-AWS-Summit.png',
      filesource: 'aws-summit.md',
      createDay: "09",
      createMonth: 'June',
      createYear: "2024"
    }
  ]
}


Mock.onGet("/api/information").reply(config => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply(config => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply(config => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply(config => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/domains").reply(config => {
  const response = database.domains;
  return [200, response];
});

Mock.onGet("/api/experience").reply(config => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply(config => {
  const response = database.blogs;
  return [200, response];
});
